module.exports = __webpack_public_path__ + "static/media/get_bg.84a3697c.jpg";